import React from 'react'

import styles from './styles'

function DisplaySocialMedia(props) {
  const { questionData } = props
  const classes = styles()

  return (
    <div className={classes.root}>
      <h3>Redes sociais do usuário:</h3>
      <ul>
        {questionData?.items?.length > 0 ? (
          questionData.items.map((social_media) => (
            <li key={social_media.type}>
              <p>
                <span>{social_media.type}: </span>
                <a href={social_media.address} target="_blank">
                  {social_media.address}
                </a>
              </p>
            </li>
          ))
        ) : questionData?.has_answer ? (
          <p>O asssessor não informou nenhuma rede social de uso profissional.</p>
        ) : (
          <p>A questão ainda não foi respondida.</p>
        )}
      </ul>
    </div>
  )
}

export default DisplaySocialMedia
